<!-- {{docTypes|json}} -->
<ng-container *ngFor="let docType of documents">
<ng-container *ngFor="let subType of docType.subTypes">
    <app-file-upload 
        (emitData)="onDocumentUpdate();"
        (uploadFailure)="onUploadFailure($event)"
        [appConfig]="appConfig.citUploaderConfig" 
        [btnName]="docType.displayName+' - '+subType.displayName" 
        [artifact]="artifact" 
        [type]="ARTIFACT_KEY.MOREINFO"
        [uploadSummary]="subType.documents"
        [docTypes]="[docType]"
        [locked]="locked"
        [hideValidation]="true"
    ></app-file-upload>
    <hr>
</ng-container>
</ng-container>
